/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.24.2
// source: trip_service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as trip_service_pb from './trip_service_pb';


export class TripDataServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetTripCoordinateData = new grpcWeb.MethodDescriptor(
    '/api.TripDataService/GetTripCoordinateData',
    grpcWeb.MethodType.UNARY,
    trip_service_pb.GetTripCoordinateDataRequest,
    trip_service_pb.GetTripCoordinateDataResponse,
    (request: trip_service_pb.GetTripCoordinateDataRequest) => {
      return request.serializeBinary();
    },
    trip_service_pb.GetTripCoordinateDataResponse.deserializeBinary
  );

  getTripCoordinateData(
    request: trip_service_pb.GetTripCoordinateDataRequest,
    metadata: grpcWeb.Metadata | null): Promise<trip_service_pb.GetTripCoordinateDataResponse>;

  getTripCoordinateData(
    request: trip_service_pb.GetTripCoordinateDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: trip_service_pb.GetTripCoordinateDataResponse) => void): grpcWeb.ClientReadableStream<trip_service_pb.GetTripCoordinateDataResponse>;

  getTripCoordinateData(
    request: trip_service_pb.GetTripCoordinateDataRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: trip_service_pb.GetTripCoordinateDataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.TripDataService/GetTripCoordinateData',
        request,
        metadata || {},
        this.methodDescriptorGetTripCoordinateData,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.TripDataService/GetTripCoordinateData',
    request,
    metadata || {},
    this.methodDescriptorGetTripCoordinateData);
  }

  methodDescriptorGetVehiclesTrips = new grpcWeb.MethodDescriptor(
    '/api.TripDataService/GetVehiclesTrips',
    grpcWeb.MethodType.UNARY,
    trip_service_pb.GetVehiclesTripsRequest,
    trip_service_pb.GetVehiclesTripsResponse,
    (request: trip_service_pb.GetVehiclesTripsRequest) => {
      return request.serializeBinary();
    },
    trip_service_pb.GetVehiclesTripsResponse.deserializeBinary
  );

  getVehiclesTrips(
    request: trip_service_pb.GetVehiclesTripsRequest,
    metadata: grpcWeb.Metadata | null): Promise<trip_service_pb.GetVehiclesTripsResponse>;

  getVehiclesTrips(
    request: trip_service_pb.GetVehiclesTripsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: trip_service_pb.GetVehiclesTripsResponse) => void): grpcWeb.ClientReadableStream<trip_service_pb.GetVehiclesTripsResponse>;

  getVehiclesTrips(
    request: trip_service_pb.GetVehiclesTripsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: trip_service_pb.GetVehiclesTripsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.TripDataService/GetVehiclesTrips',
        request,
        metadata || {},
        this.methodDescriptorGetVehiclesTrips,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.TripDataService/GetVehiclesTrips',
    request,
    metadata || {},
    this.methodDescriptorGetVehiclesTrips);
  }

}

